import React, { useEffect, useState } from "react";

import {
    ResponsiveContainer,
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    PieChart,
    Pie,
    Cell,
    BarChart,
    Bar,
    Legend
} from "recharts";

import {
    FaBolt,
    FaCloud,
    FaGauge,
    FaDroplet,
    FaTrash
} from "react-icons/fa6";

import apiClient from "../../shared/API/apiClient";

import {
    useReportingYear
} from "../../context/ReportingYearContext";

const COLORS = [
    "#ef4444",
    "#2563eb",
    "#10b981",
    "#f59e0b",
    "#8b5cf6"
];
const SITE_COLORS = [
    "#2563eb",
    "#10b981",
    "#f59e0b",
    "#ef4444",
    "#8b5cf6",
    "#06b6d4",
    "#84cc16",
    "#f97316",
    "#14b8a6",
    "#ec4899"
];
const ICONS = {
    energy: FaBolt,
    carbon: FaCloud,
    intensity: FaGauge,
    water: FaDroplet,
    waste: FaTrash
};

const formatNumber = value => {
    const num = Number(value);
    return value == null || value === ""
        ? "-"
        : num.toLocaleString("en-IN", {
              minimumFractionDigits: Math.abs(num) < 1 ? 4 : 0,
              maximumFractionDigits: Math.abs(num) < 1 ? 4 : 2
          });
};

const ComparisonAnalysisPage = () => {

    const {reportingYear, reportingYearId } = useReportingYear();
    const [reportingYearInfo, setReportingYearInfo] =useState(null);
    const [loading, setLoading] = useState(false);
    const [report, setReport] = useState(null);
    const [legalEntities, setLegalEntities] = useState([]);
    const [reportingYears,setReportingYears]= useState([]);
    const [yearError, setYearError] = useState("");
    const [errors, setErrors] = useState({
    legal_entity_id: "",
    base_reporting_year_id: "",
    compare_reporting_year_id: "",
    baseline_month: "",
    comparison_month: "",
    base_entity_id: "",
    compare_entity_id: ""
});
    const setFieldError = (field, message = "") => {

    setErrors(prev => ({
        ...prev,
        [field]: message
    }));
};
    // =====================================
    // ENTITY
    // =====================================
useEffect(() => {

   const loadReportingYear = async () => {

    try {

        const res = await apiClient.post("/api/reportingyear");

        if (res.data.code === 200) {

            const data = res.data.data || [];

            setReportingYears(data);

            setReportingYearInfo(
                data.find(y => Number(y.id) === Number(reportingYearId)) || null
            );
        }

    } catch (e) {

        console.error("Reporting year API error:", e);
    }
};

    loadReportingYear();

}, [reportingYearId]);
    useEffect(() => {

        const load = async () => {

            if(!reportingYearId) {
                return;
            }

            try {

                const res =
                    await apiClient.get(
                        "/api/legal-entities-by-year",
                        {
                            params: {
                                reporting_year_id:
                                    reportingYearId
                            }
                        }
                    );

                setLegalEntities(
                    res.data.data || []
                );

            } catch {

                setLegalEntities([]);
            }
        };

        load();

    }, [reportingYearId]);

    // =====================================
    // FILTER
    // =====================================

    const [filters, setFilters] = useState({
    comparison_type: "",
    legal_entity_id: "",
    base_reporting_year_id: "",
    compare_reporting_year_id: "",
    baseline_month: "",
    comparison_month: "",
    base_entity_id: "",
    compare_entity_id: ""
        });

      const handleFilterChange = (field, value) => {

    const updated = {
        ...filters,
        [field]: value
    };

    if(field === "filter_type") {

        updated.quarter = "";
        updated.month = "";

        if(value === "CUSTOM" && reportingYearInfo) {
            updated.from_date =
                reportingYearInfo.start_date;

            updated.to_date =
                reportingYearInfo.end_date;
        }

        if(value !== "CUSTOM") {
            updated.from_date = "";
            updated.to_date = "";
        }
    }

    setFilters(updated);
};

    // =====================================
    // LOAD
    // =====================================

    const loadReport = async () => {

        if(!reportingYearId) {
        return;
            }
            
    const validationErrors = {};

if (!filters.comparison_type)
        validationErrors.comparison_type = "Please select Compare criteria";
if (filters.comparison_type === "YEAR") {
    if (!filters.legal_entity_id)
        validationErrors.legal_entity_id = "Legal Entity is required";

    if (!filters.base_reporting_year_id)
        validationErrors.base_reporting_year_id = "Baseline FY is required";

    if (!filters.compare_reporting_year_id)
        validationErrors.compare_reporting_year_id = "Comparison FY is required";

    if (
        filters.base_reporting_year_id &&
        filters.compare_reporting_year_id &&
        filters.base_reporting_year_id === filters.compare_reporting_year_id
    ) {
        validationErrors.base_reporting_year_id =
            "Baseline FY and Comparison FY cannot be the same";
        validationErrors.compare_reporting_year_id =
            "Baseline FY and Comparison FY cannot be the same";
    }
}

if (filters.comparison_type === "MONTH") {
    if (!filters.legal_entity_id)
        validationErrors.legal_entity_id = "Legal Entity is required";

    if (!filters.baseline_month)
        validationErrors.baseline_month = "Baseline Month is required";

    if (!filters.comparison_month)
        validationErrors.comparison_month = "Comparison Month is required";
    if (filters.comparison_month && filters.baseline_month && filters.baseline_month === filters.comparison_month) 
     {
        validationErrors.baseline_month =
            "Baseline and Comparison Months cannot be the same";
        validationErrors.comparison_month =
            "Baseline and Comparison Months cannot be the same";
    }
}

if (filters.comparison_type === "ENTITY") {
    if (!filters.base_entity_id)
        validationErrors.base_entity_id = "Baseline Entity is required";

    if (!filters.compare_entity_id)
        validationErrors.compare_entity_id = "Comparison Entity is required";
     if (filters.compare_entity_id && filters.base_entity_id && filters.base_entity_id === filters.compare_entity_id) 
     {
        validationErrors.base_entity_id =
            "Baseline and Comparison Entity cannot be the same";
        validationErrors.compare_entity_id =
            "Baseline and Comparison Entity cannot be the same";
    }
}

setErrors(validationErrors);

if (Object.keys(validationErrors).length > 0) return;
        try {

            setLoading(true);

            const response =
            await apiClient.get(
                "/api/reports/comparitive-analysis-dashboard",
                {
                    params: {
                            reporting_year_id: reportingYearId,
                            legal_entity_id: filters.legal_entity_id,
                            ...filters
                        }
                }
            );

        setReport(response.data);

        } finally {

            setLoading(false);
        }
    };
    useEffect(() => {

    setReport(null);

        }, [
            filters.comparison_type
        ]);

    if(loading) {

        return (
            <div className="dash-loader-wrapper">
                <div className="dash-loader" />
            </div>
        );
    }
    return (

    <div className="dash-page">

        <div className="dash-page-title">
            Comparative Analysis
        </div>

        <div className="dash-page-subtitle">
             Year-over-year, month-over-month and entity performance comparison
        </div>

        {/* FILTER */}

            <div className="filter-card">

                            <div className="filter-group">
                                <label>Compare</label>
                                
                                    <select className="filter-fields" value={filters.comparison_type}
                                    
                                    onChange={e =>
                                        setFilters({
                                            comparison_type: e.target.value,
                                            legal_entity_id: "",
                                            base_reporting_year_id: "",
                                            compare_reporting_year_id: "",
                                            baseline_month: "",
                                            comparison_month: "",
                                            base_entity_id: "",
                                            compare_entity_id: ""
                                        })
                                    }
                                >
                                <option value="">Select</option>
                                <option value="YEAR">Year vs Year</option>
                                <option value="MONTH">Month vs Month</option>
                                <option value="ENTITY">Entity vs Entity</option>
                            </select>
                            {errors.comparison_type && <div className="field-error">{errors.comparison_type}</div>}
                            </div>
                            {
                                ["YEAR", "MONTH"].includes(filters.comparison_type) && (

                                    <div className="filter-group">

                                        <label>Legal Entity</label>

                                        <select
                                            className="filter-fields"
                                            value={filters.legal_entity_id}
                                            onChange={e =>
                                                setFilters({
                                                    ...filters,
                                                    legal_entity_id: e.target.value
                                                })
                                            }
                                        >

                                            <option value="">Select</option>

                                            {
                                                legalEntities.map(e => (
                                                    <option
                                                        key={e.entity_id}
                                                        value={e.entity_id}
                                                    >
                                                        {e.entity_name}
                                                    </option>
                                                ))
                                            }

                                        </select>
                                        {errors.legal_entity_id && <div className="field-error">{errors.legal_entity_id}</div>}
                                    </div>
                                )
                            }
                    
                        {
                                        filters.comparison_type === "YEAR" && (
                                        <>
                                    <div className="filter-group">
                                        <label>Baseline FY</label>
                                        <select
                                            className="filter-fields"
                                            value={filters.base_reporting_year_id}
                                            onChange={e => {
                                                const value = e.target.value;

                                                setFilters({ ...filters, base_reporting_year_id: value });

                                                setErrors(prev => ({
                                                    ...prev,
                                                    base_reporting_year_id: value && value === filters.compare_reporting_year_id
                                                        ? "Baseline FY and Comparison FY cannot be the same."
                                                        : "",
                                                    compare_reporting_year_id: value && value === filters.compare_reporting_year_id
                                                        ? "Baseline FY and Comparison FY cannot be the same."
                                                        : ""
                                                }));
                                            }}
                                        >
                                            <option value="">Select</option>
                                            {reportingYears.map(y => (
                                                <option key={y.id} value={y.id}>{y.year_label}</option>
                                            ))}
                                        </select>
                                        {errors.base_reporting_year_id && <div className="field-error">{errors.base_reporting_year_id}</div>}
                                    </div>

                                    <div className="filter-group">
                                        <label>Comparison FY</label>
                                        <select
                                            className="filter-fields"
                                            value={filters.compare_reporting_year_id}
                                            onChange={e => {
                                                            const value = e.target.value;
                                                            if (value && value === filters.base_reporting_year_id) {
                                                                    setYearError(
                                                                        "Baseline FY and Comparison FY cannot be the same."
                                                                    );
                                                                } else {
                                                                    setYearError("");
                                                                }
                                                            setFilters({ ...filters, compare_reporting_year_id: value });
                                                        }}
                                        >
                                            <option value="">Select</option>
                                            {reportingYears.map(y => (
                                                <option key={y.id} value={y.id}>{y.year_label}</option>
                                            ))}
                                        </select>
                                        {errors.compare_reporting_year_id && <div className="field-error">{errors.compare_reporting_year_id}</div>}
                                        
                                    </div>
                                </>
                            )
                        }
                        {
                                filters.comparison_type === "MONTH" && (
                                    <>
                                        <div className="filter-group">
                                            <label>Baseline Month</label>
                                            <input
                                                type="month"
                                                className="filter-fields"
                                                value={filters.baseline_month}
                                                onChange={e => setFilters({ ...filters, baseline_month: e.target.value })}
                                            />
                                            {errors.baseline_month && <div className="field-error">{errors.baseline_month}</div>}
                                        </div>

                                        <div className="filter-group">
                                            <label>Comparison Month</label>
                                            <input
                                                type="month"
                                                className="filter-fields"
                                                value={filters.comparison_month}
                                                onChange={e => setFilters({ ...filters, comparison_month: e.target.value })}
                                            />
                                             {errors.comparison_month && <div className="field-error">{errors.comparison_month}</div>}
                                        </div>
                                    </>
                                )
                        }
                
                        {
                    filters.comparison_type === "ENTITY" && (
                    <>
                    <div className="filter-group">
                        <label>Baseline Entity</label>
                        <select
                            className="filter-fields"
                            value={filters.base_entity_id}
                            onChange={e => setFilters({ ...filters, base_entity_id: e.target.value })}
                        >
                            <option value="">Select</option>
                            {legalEntities.map(e => (
                                <option key={e.entity_id} value={e.entity_id}>
                                    {e.entity_name}
                                </option>
                            ))}
                        </select>
                        {errors.base_entity_id && <div className="field-error">{errors.base_entity_id}</div>}
                    </div>

                        <div className="filter-group">
                            <label>Comparison Entity</label>
                            <select
                                className="filter-fields"
                                value={filters.compare_entity_id}
                                onChange={e => setFilters({ ...filters, compare_entity_id: e.target.value })}
                            >
                                <option value="">Select</option>
                                {legalEntities.map(e => (
                                    <option key={e.entity_id} value={e.entity_id}>
                                        {e.entity_name}
                                    </option>
                                ))}
                            </select>
                            {errors.compare_entity_id && <div className="field-error">{errors.compare_entity_id}</div>}
                        </div>
                        </>
                        )
                        }
                
                <div className="filter-group">

                    <label>&nbsp;</label>

                    <button className="org-btn-save" onClick={loadReport}>
                        Generate Report
                    </button>

                </div>

        </div>
        {
                !report && (

                    <div className="empty-entity">
          <div className="empty-entity__icon"><i className="fa-solid fa-building" /></div>
          <div className="empty-entity__title">Select comparison criteria</div>
          <div className="empty-entity__sub">
            Select comparison parameters and generate report.
          </div>
        
        </div>
                )
            }

        {
            report &&(() => {

                const {
                        applied_filter,
                        baseline,
                        comparison,
                        kpis,
                        comparison_chart,
                        variance_chart,
                        table,
                        features
                    } = report;

                    const highestGrowth = [...table]
                    .filter(row => row.key !== "intensity" && row.change_percent > 0)
                    .sort((a, b) => b.change_percent - a.change_percent)[0];

                    const largestImpact = [...table]
                    .filter(row => row.key !== "intensity")
                    .sort(
                        (a, b) =>
                            Math.abs(b.baseline - b.comparison) -
                            Math.abs(a.baseline - a.comparison)
                    )[0];

                return (

                    <>

                       <div className="reporting_year_line">
                        <strong>{applied_filter?.label || "-"}</strong> |{" "}
                        {applied_filter?.from_date || "-"} to{" "}
                        {applied_filter?.to_date || "-"}
                    </div>
                        {/* KPI */}

                        {
                            features.show_kpis && (
                                <div className="dash-stat-grid" style={{ gridTemplateColumns: `repeat(${kpis.length},1fr)` }}>
                                    {
                                        kpis.map(kpi => {
                                            const Icon = ICONS[kpi.key];

                                            return (
                                                <div key={kpi.key} className="dash-stat-card">

                                                    <div className="dash-stat-header">
                                                    <span className="metric-card__icon">
                                                        <Icon />
                                                        </span>
                                                        <div className="dash-stat-label">{kpi.title}</div>
                                                    </div>

                                                    <div className="compare-values">

                                                        <div>
                                                            <div className="compare-label">{baseline?.label || "-"}</div>
                                                            <div className="compare-value">{kpi.baseline}</div>
                                                        </div>

                                                        <div>
                                                            <div className="compare-label">{comparison?.label || "-"}</div>
                                                            <div className="compare-value">{kpi.comparison}</div>
                                                        </div>

                                                    </div>

                                                    <div className="compare-change">
                                                        {kpi.change_percent > 0 ? "▲" : kpi.change_percent < 0 ? "▼" : "▬"} {kpi.change_percent}%
                                                    </div>

                                                    <div className="dash-stat-sub">{kpi.unit}</div>

                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            )
                        }
                        
                        <div className="chart-row">

                            {
                            features.show_comparison_chart && (
                                <div className="chart-card">
                                    <h4>Comparative Performance</h4>
                                    <ResponsiveContainer width="100%" height={350}>
                                        <BarChart data={comparison_chart}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="metric" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />
                                            <Bar dataKey="baseline" name={baseline.label} fill="#2563eb" />
                                            <Bar dataKey="comparison" name={comparison.label} fill="#10b981" />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            )
                        }
                        
                    </div>
                    <div className="dash-stat-grid">
                        <div className="dash-stat-card">
                            <div className="dash-stat-label">Highest Growth</div>
                            <div className="dash-stat-value">
                                {highestGrowth ? highestGrowth.title : "No Growth"}
                            </div>
                            {highestGrowth && (
                                <div className="summary-card-change positive">
                                    ▲ {highestGrowth.change_percent}%
                                </div>
                            )}
                        </div>

                        <div className="dash-stat-card">
                            <div className="dash-stat-label">Largest Impact</div>
                            <div className="dash-stat-value">{largestImpact?.title}</div>
                            <div className="summary-card-change">
                                {Math.abs(
                                    largestImpact.baseline - largestImpact.comparison
                                ).toLocaleString()}
                            </div>
                        </div>
                    </div>
                    <div className="chart-row">  
                       {
                        features.show_variance_chart && (
                            <div className="chart-card">
                                <h4>Variance Analysis (%)</h4>
                                <ResponsiveContainer width="100%" height={300}>
                                    <BarChart data={variance_chart}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="metric" />
                                        <YAxis />
                                        <Tooltip />
                                        <Bar dataKey="change">
                                            {variance_chart.map((entry, index) => (
                                                <Cell
                                                    key={index}
                                                    fill={entry.change >= 0 ? "#10b981" : "#ef4444"}
                                                />
                                            ))}
                                        </Bar>
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        )
                    }
                    
                        </div>
                        {
                        features.show_table && (
                            <div className="table-card">
                                <h4>Detailed Comparison</h4>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Metric</th>
                                            <th>{baseline.label}</th>
                                            <th>{comparison.label}</th>
                                            <th>Change %</th>
                                            <th>Unit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {table.map((row, index) => (
                                            <tr key={index}>
                                                <td>{row.title}</td>
                                                <td>{formatNumber(row.baseline)}</td>
                                                <td>{formatNumber(row.comparison)}</td>
                                                <td style={{ color: row.change_percent >= 0 ? "#16a34a" : "#dc2626" }}>
                                                    {row.change_percent}%
                                                </td>
                                                <td>{row.unit}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )
                    }

                    </>
                );
            })()
        }

                    </div>
            );
            };

export default ComparisonAnalysisPage;